const e = [
  400,
  500,
  600,
  700
];
e.regular = e[0];
e.medium = e[1];
e.semiBold = e[2];
e.bold = e[3];
export {
  e as default
};
